import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API_URLS } from "./apis/urls";
import Api from "./utils/apiCall";
import { tokenService } from "../../utils/tokenService";

interface AuthState {
  data: any;
  loading: "idle" | "pending" | "fulfilled" | "rejected";
  error: string | null;
  user: any;
  action: string | null;
}

interface AuthData {
  email: string;
  password: string;
  role: string;
}

const authInitialState: AuthState = {
  data: null,
  loading: "idle",
  error: null,
  user: null,
  action: null,
};


export const getUserLogin: any = createAsyncThunk(
  "auth/login",
  async (credentials: AuthData, thunkAPI) => {
    try {
      const response = await Api.post(API_URLS.GET_LOGIN, credentials);
      console.log('response--', response)
      if (response?.data?.data?.access_token) {
        tokenService.setToken(response?.data?.data?.access_token);
      }
      localStorage.setItem("user", JSON.stringify(response?.data?.data?.user));
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);

export const getUserLoginData: any = createAsyncThunk(
  "auth/login-data",
  async (credentials: AuthData, thunkAPI) => {
    try {
      const response = await Api.post(API_URLS.LOGIN_DATA, credentials);
      const resData = response?.data?.data;
      const userObj = resData?.data || resData;

      if (userObj) {
        const existingUser = localStorage.getItem("user");
        let mergedUser = userObj;
        if (existingUser && existingUser !== "undefined") {
          try {
            mergedUser = { ...JSON.parse(existingUser), ...userObj };
          } catch (e) {}
        }
        localStorage.setItem("user", JSON.stringify(mergedUser));
      }

      const hrmsRoles = resData?.hrms_role;
      const empPermission = resData?.emp_permission || [];

      const allowedEmpPermissions = empPermission.map((permission: any) => permission?.permission?.code);
      const allowedRolePermissions = hrmsRoles?.role?.roles_permissions?.map((rp: any) => rp.permissions?.code) || [];

      const allowedPermissions = [...allowedEmpPermissions, ...allowedRolePermissions];

      localStorage.setItem("allowed_permissions", JSON.stringify(allowedPermissions));
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);

export const userLogout: any = createAsyncThunk(
  "auth/logout",
  async (_, thunkAPI) => {
    try {
      // Call logout API with empty data object
      const response = await Api.post(API_URLS.LOGOUT, {});
      return response;
    } catch (error: any) {
      // Even if API fails, we should still allow logout
      const errorMessage = Api.getErrorMessage(error);
      // Don't reject, just return error message so logout can proceed
      return thunkAPI.fulfillWithValue({ error: errorMessage });
    }
  }
);



const authSlice = createSlice({
  name: "auth",
  initialState: authInitialState,
  reducers: {
    logout: (state: any) => {
      state.data = null;
      state.loading = "idle";
      state.action = "logout";
    },
    resetAuthError: (state: any) => {
      state.loading = "idle";
      state.error = null;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(getUserLogin.pending, (state) => {
      state.loading = "pending";
    });
    builder.addCase(getUserLogin.fulfilled, (state, action) => {
      state.loading = "fulfilled";
      state.user = action.payload;
      state.data = null;
    });
    builder.addCase(getUserLogin.rejected, (state, action) => {
      state.loading = "rejected";
      state.error = action.payload as string;
    });



    builder.addCase(getUserLoginData.pending, (state) => {
      state.loading = "pending";
    });
    builder.addCase(getUserLoginData.fulfilled, (state, action) => {
      state.loading = "fulfilled";
      state.user = action.payload;
      state.data = null;
    });
    builder.addCase(getUserLoginData.rejected, (state, action) => {
      state.loading = "rejected";
      state.error = action.payload as string;
    });

    // Logout API cases
    builder.addCase(userLogout.pending, (state) => {
      state.loading = "pending";
      state.action = "logout";
    });
    builder.addCase(userLogout.fulfilled, (state, action) => {
      state.loading = "fulfilled";
      state.action = "logout";
      state.data = action.payload;
    });
    builder.addCase(userLogout.rejected, (state, action) => {
      state.loading = "rejected";
      state.action = "logout";
      state.error = action.payload as string;
    });

  },
});

export const { logout, resetAuthError } = authSlice.actions;

export default authSlice.reducer;
